import React, { useEffect } from 'react';
import useAliceGPT from '../../Hooks/AliceGPT/useAliceGPT';
import * as AliceGPTEvents from '../../Context/AliceGPT/AliceGPTContextEvents';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import startsWithNumber from '../Helpers/Validators/startsWithNumber';
import { useTranslation } from 'react-i18next';
import { LanguagesMap } from '../OrganizationSettings/LanguagesMap';
import { Checkbox } from '@progress/kendo-react-inputs';

function CopilotProjectDetailsForm({ checkDuplicateProjectName, showPassWorkItemFields, showAIFields, showLanguageDropdown }) {

    const { t } = useTranslation("create_project/alice_project_details_form", { useSuspense: false });

    const [{ form, showAdvancedConfigurations }, dispatch] = useAliceGPT();

    const isProjectNameUsed = checkDuplicateProjectName();
    const hasSpecialCharacters = /[^a-zA-Z0-9 ]/g.test(form.projectName);

    useEffect(() => {
        debugger;
        if (showPassWorkItemFields !== undefined && showPassWorkItemFields === true) {
            dispatch({ type: AliceGPTEvents.FORM_UPDATED, payload: { ...form, passWorkItemFields: true } });
        }
    }, [showPassWorkItemFields])

    function handleFormChange(e) {
        const { name, value, maxLength } = e.target;
        let newValue = value;
        if (maxLength && maxLength > 0 && value.length > maxLength) {
            newValue = value.substring(0, maxLength);
        };
        const newFormDetails = { ...form, [name]: newValue };
        dispatch({ type: AliceGPTEvents.FORM_UPDATED, payload: newFormDetails });
    }

    function toggleAdvancedConfiguration() {
        if (showAdvancedConfigurations) {
            dispatch({ type: AliceGPTEvents.HIDE_ADVANCED_CONFIGURATIONS });
        } else {
            dispatch({ type: AliceGPTEvents.SHOW_ADVANCED_CONFIGURATIONS });
        }
    }

    return (
        <div className='container-fluid' style={{ marginTop: "7rem" }}>
            <div className='row'>
                <div className='col-4'>
                    <img
                        src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/codeless-one-logo.svg`}
                        width={250}
                    />
                    <div style={{ marginTop: "4rem" }}>
                        <iframe width="380" height="220" src="https://www.youtube.com/embed/Pm2dZjfWNOU?si=BisclHTjF1IjOrp3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </div>
                <div className='col-8'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className="col-12 my-2">
                                <h3 style={{ fontWeight: 600 }}>Introducing AI-Powered No-code Prototyping</h3>
                                <p style={{ fontSize: "14px" }}>
                                    Codeless ONE empowers you to build business applications with AI and automation.  It streamlines the process by suggesting app
                                    structures, prototyping quickly, and automatically validating your design and requirements - all without writing code.
                                </p>
                                <p className='font-size-2'>
                                    Let's build your first application prototype in minutes.
                                </p>
                            </div>
                            <form
                                className='col-12'
                                onSubmit={(e) => e.preventDefault()}
                            >
                                <div>
                                    <div className='form-group'>
                                        <label className='form-label copilot-label' htmlFor='app-name-field' required>
                                            Give me the name of your application
                                            {
                                                isProjectNameUsed && (
                                                    <span className='text-danger'>
                                                        &nbsp;{t("errors.app_name_taken")}
                                                    </span>
                                                )
                                            }
                                            {
                                                hasSpecialCharacters && (
                                                    <span className='text-danger'>
                                                        &nbsp;{t("errors.app_name_has_sp_chars")}
                                                    </span>
                                                )
                                            }
                                            {
                                                form.projectName &&
                                                startsWithNumber(form.projectName.trim()) && (
                                                    <span className='text-danger'>
                                                        &nbsp;{t("errors.app_name_can_not_start_with_number")}
                                                    </span>
                                                )
                                            }
                                        </label>
                                        <input
                                            id="app-name-field"
                                            type='text'
                                            className='form-control'
                                            placeholder='Enter the application name here, such as CRM, Asset Management, Employee Management, and Project Management'
                                            name='projectName'
                                            onChange={handleFormChange}
                                            value={form.projectName}
                                            maxLength={64}
                                            autoFocus
                                        />
                                    </div>
                                    {
                                        showLanguageDropdown &&
                                        <div className="form-group">
                                            {/* TODO: Support static translation */}
                                            <label className="form-label">
                                                {t("form_labels.select_language")}
                                            </label>
                                            <DropDownList
                                                name="language"
                                                data={LanguagesMap}
                                                value={form.language}
                                                textField='name'
                                                onChange={handleFormChange}
                                            />
                                        </div>
                                    }
                                    {
                                        showAIFields &&
                                        <div className='form-group'>
                                            <label className='form-label copilot-label'>
                                                Provide me a description about this application (optional).
                                            </label>
                                            <textarea
                                                className='form-control'
                                                placeholder='Enter the Description'
                                                name='description'
                                                onChange={handleFormChange}
                                                value={form.description}
                                                rows={7}
                                            />
                                        </div>
                                    }
                                    {
                                        showPassWorkItemFields &&
                                        <div className='form-group mt-2'>
                                            <Checkbox
                                                name='passWorkItemFields'
                                                checked={form.passWorkItemFields}
                                                onChange={handleFormChange}
                                                label="Pass selected work items as app input (optional)"
                                                labelPlacement='right'
                                            />
                                        </div>
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CopilotProjectDetailsForm;